export const DEFAULT_USERNAME = 'chris';
export const LONGLIST_QUESTION_MIN_LENGTH = 3;
export const IS_CLOSABLE_MENU_ITEM_NAME = 'Confirmation'; // 'isCloseable';
export const STRING_QUESTION_LARGE_TAG = 'LARGE';
export const EXCLUSIVE_TAG = 'EXCLUSIVE';
export const METRIC = 'metric';
export const IMPERIAL = 'imperial';
import {
  convertMetresToFtnIn,
  convertKgToStonePounds,
  getCmToInches,
} from '../utilities/common';

export const ure_section_names = {
  YOUR_BASIC_DETAILS: 'Your basic details',
  PERSONAL_DETAILS: 'Personal details',
  YOUR_MENTAL_HEALTH: 'Your mental health',
  YOUR_PHYSICAL_HEALTH: 'Your physical health',
  YOUR_PHYSICAL_HEALTH_CONT: 'Your physical health continued',
  YOUR_GENERAL_HEALTH: 'Your general health',
  LIFESTYLE: 'Lifestyle',
  LIFESTYLE_CONT: 'Lifestyle continued...',
};

export const ure_section_pathnames = {
  YOUR_BASIC_DETAILS: 'Your_Basic_Details',
  KEY_INFO_IFA: 'Key_Info_IFA',
  MENTAL_HEALTH: 'Mental_Health',
  HEALTH_MAJOR_IFA: 'Health_Major_IFA',
  DETAILED_MEDICAL_IFA: 'Detailed_Medical_IFA',
  HEALTH_COVID: 'Health_Covid',
  ALCOHOL_DRUGS_IFA: 'Alcohol_Drugs_IFA',
  LIFESTYLE_IFA: 'Alcohol_Drugs_IFA',
};

export const ure_slice_name = 'URE';

export const ure_thunks = {
  URE_FETCH_START_ENQUIRY: `${ure_slice_name}/fetchStartEquiry`,
  URE_FETCH_ENQUIRY_BY_ID: `${ure_slice_name}/fetchEnquiryById`,
  URE_POST_ENQUIRY_BY_ID: `${ure_slice_name}/postEquiryById`,
  URE_FETCH_LOOKING_QUESTION_OPTION: `${ure_slice_name}/fetchLookUpQuestionOption`,
  URE_POST_CLOSE_ENQUIRY: `${ure_slice_name}/postCloseEnquiry`,
  URE_POST_CREATE_APPLICATION_UNDERWRITING_ENQUIRY: `${ure_slice_name}/postCreateApplicantUnderwritingEnquiryByApplicantId`,
  URE_FETCH_APPLICANT_UNDERWRITING_ENQUIRY: `${ure_slice_name}/fetchApplicantUnderwritingEnquiryByApplicantId`,
  URE_POST_APPLICATION_ENQUIRY_BY_ID: `${ure_slice_name}/postApplicationEnquiryById`,
  URE_POST_APPLICATION_APPLICANT_BY_ID: `${ure_slice_name}/postApplicationApplicantById`,
  URE_POST_TRANSIENT_APPLICATION_ENQUIRY_BY_ID: `${ure_slice_name}/postTransientApplicationApplicantById`,
  URE_POST_ACCEPT_PRE_UNDERWRITING_DECLARATION_BY_ID: `${ure_slice_name}/postAcceptPreUnderwritingDeclarationById`,
  URE_POST_ACCEPT_POST_UNDERWRITING_DECLARATION_BY_ID: `${ure_slice_name}/postAcceptPostUnderwritingDeclarationById`,
  URE_POST_UNDERWRITING_START_PRESALE: `${ure_slice_name}/postUnderwritingStartPreSale`,
};

export const questionTypes = {
  STRING: 'STRING',
  DATE: 'DATE',
  PAST_DATE: 'PAST_DATE',
  FUTURE_DATE: 'FUTURE_DATE',
  OPTION_GROUP: 'OPTION_GROUP',
  OPTION_LIST: 'OPTION_LIST',
  OPTION_BACKED: 'OPTION_BACKED',
  NUMBER: 'NUMBER',
  INTEGER: 'INTEGER',
  HEIGHT: 'HEIGHT',
  WEIGHT_MALE: 'WEIGHT_MALE',
  WEIGHT_FEMALE: 'WEIGHT_FEMALE',
  WAIST_SIZE: 'WAIST_SIZE',
  EARNINGS: 'EARNINGS',
};

export const multiValued = {
  YES: 'isMulti',
  NO: 'isNotMulti',
};

export const unitOptions = {
  IMPERIAL: IMPERIAL,
  METRIC: METRIC,
};

export const heightUnitQuestionName = 'HEIGHT_UNITS';
export const weightUnitQuestionName = 'WEIGHT_UNITS';
export const waistUnitQuestionName = 'WAIST_UNITS';

export const unitQuestionConversions = [
  {
    name: 'WAIST_SIZE',
    unitQuestionName: 'WAIST_UNITS',
    convert: getCmToInches,
    units: {
      metric: ['cm'],
      imperial: ['in'],
    },
    label: 'waist measurement',
  },
  {
    name: 'HEIGHT',
    unitQuestionName: 'HEIGHT_UNITS',
    convert: convertMetresToFtnIn,
    units: {
      metric: ['m'],
      imperial: ['ft', 'in'],
    },
    label: 'height',
  },
  {
    name: 'WEIGHT',
    unitQuestionName: 'WEIGHT_UNITS',
    convert: convertKgToStonePounds,
    units: {
      metric: ['kg'],
      imperial: ['st', 'lbs'],
    },
    label: 'weight',
  },
  {
    name: 'WEIGHT_MALE',
    unitQuestionName: 'WEIGHT_UNITS',
    convert: convertKgToStonePounds,
    units: {
      metric: ['kg'],
      imperial: ['st', 'lbs'],
    },
    label: 'weight',
  },
  {
    name: 'WEIGHT_FEMALE',
    unitQuestionName: 'WEIGHT_UNITS',
    convert: convertKgToStonePounds,
    units: {
      metric: ['kg'],
      imperial: ['st', 'lbs'],
    },
    label: 'weight',
  },
];

export const ure_unit_inputs = {
  METRE_INPUT_MAXLENGTH: 6,
  FEET_INPUT_MAXLENGTH: 1,
  INCH_INPUT_MAXLENGTH: 2,
  KILO_INPUT_MAXLENGTH: 6,
  STONE_INPUT_MAXLENGTH: 2,
  POUND_INPUT_MAXLENGTH: 2,
};

export const ure_dates = {
  MONTH_INPUT_MAXLENGTH: 9,
  YEAR_INPUT_MAXLENGTH: 4,
  YEAR_SCOPE_REGEX: /^(19[0-9]\d|20[0-9]\d|2099)$/,
  MONTH_SCOPE_REGEX: /^([1-9]|0[1-9]|1[012])$/,
};

export const ure_section_status = {
  NOT_STARTED: 'notStarted',
  IN_PROGRESS: 'inProgress',
  COMPLETE: 'complete',
};

export const tab_section_aliases = {
  ADDITIONAL: 'Additional',
};

export const tab_section_sub_tag = 'SUB_';
